import { render } from "./Registered.vue?vue&type=template&id=af8dd616&scoped=true"
import script from "./Registered.vue?vue&type=script&lang=js"
export * from "./Registered.vue?vue&type=script&lang=js"

import "./Registered.vue?vue&type=style&index=0&id=af8dd616&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af8dd616"]])

export default __exports__